var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productBlocks)?_c('section',{staticClass:"ProductBlocks"},[_c('div',{staticClass:"container"},[_c('ProductStrates')],1),_c('ProductInstallation')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }